import { type TAuthor as TApiAuthor } from '@core/api'

import { type TAuthor } from '@core/models'

import { convertProfile } from './convertProfile'

export const convertAuthor = (apiAuthor: TApiAuthor): TAuthor => {
    const { avatar, background, profile, username, id, stats, date_created, registration_type } =
        apiAuthor

    const author: TAuthor = {
        id,
        username,
        avatarUrl: avatar,
        backgroundUrl: background,
        profile: convertProfile(profile),
        dateCreated: date_created,
        browsableAudioCount: stats?.browsable_audio_count ?? 0,
        accessibleProjectsCount: stats?.projects_accessible_count ?? 0,
        registrationType: registration_type,
        supportersCount: stats?.supporters_count ?? 0,
    }

    if (stats) {
        author.hasPublicCollections = stats.public_collections_count > 0
    }

    return author
}
